import { BaseApiClient } from "./BaseApiClient";
export const EVENTS_ENDPOINTS = {
    BY_COUPON_ID: "/Events/GetByCouponId",
    BY_EVENT_ID: "/Events/GetByEventId",
    BY_LEAGUE_ID: "/Events/GetByLeagueId",
    BY_SPORT_ID: "/Events/GetBySportId",
    BY_EVENT_ID_OR_BY_LEAGUE_ID: "/Events/GetByEventIdOrByLeagueId",
    FROM_TOP_LEAGUES_BY_SPORT_ID: "/Events/GetFromTopLeaguesBySportId",
    FROM_OUTRIGHT_BY_LEAGUE_ID: "/Events/GetFromOutrightByLeagueId",
    COUNT_BY_TAG: "/Events/GetCountByTag",
    BY_REGION_ID: "/Events/GetByRegionIdAndSportId",
    PERSONALIZED_LIVE_EVENTS_BY_ID: "/Events/GetPersonalizedLive",
    BY_ID_FOR_BETSLIP: "/Events/GetByEventIdForBetSlip",
    PERSONALIZED_PRELIVE_BY_SPORT_ID: "/Events/GetPersonalizedPreLiveBySportId",
    PERSONALIZED_PRELIVE_EVENTS: "/Events/GetPersonalizedPreLiveEvents"
};
/**
 * EventsApiClient - client for fetching Leagues BFF endpoints
 * @export
 * @class EventsApiClient
 * @extends {BaseApiClient}
 */
export class EventsApiClient extends BaseApiClient {
    /**
     * Fetch events by coupon id from BFF
     * @param {request} EventsByCouponIdRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    getByCouponId(request) {
        let fetchOptions = {
            request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.BY_COUPON_ID, fetchOptions);
    }
    /**
     * Fetch events by ids from BFF
     * @param {request} EventsByEventIdRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    getByEventsId(request) {
        let fetchOptions = {
            request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.BY_EVENT_ID, fetchOptions);
    }
    /**
     * Fetch events by league ids from BFF
     * @param {request} EventsByLeagueIdRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    getByLeaguesId(request) {
        let fetchOptions = {
            request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.BY_LEAGUE_ID, fetchOptions);
    }
    /**
     * Fetch events by sport ids from BFF
     * @param {request} EventsBySportIdRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    getBySportId(request) {
        let fetchOptions = {
            request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.BY_SPORT_ID, fetchOptions);
    }
    /**
     * Fetch events from top leagues by sport id from BFF
     * @param {request} EventsFromTopLeaguesBySportIdRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    getFromTopLeaguesBySportId(request) {
        let fetchOptions = {
            request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.FROM_TOP_LEAGUES_BY_SPORT_ID, fetchOptions);
    }
    /**
     * Fetch events count by tag from BFF
     * @param {request} EventsCountByTagRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    getCountByTag(request) {
        let fetchOptions = {
            request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.COUNT_BY_TAG, fetchOptions);
    }
    /**
     * Fetch events count by tag from BFF
     * @param {request} EventsByRegionIdAndSportIdRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    getByRegionId(request) {
        let fetchOptions = {
            request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.BY_REGION_ID, fetchOptions);
    }
    /**
     * Fetch events by event Ids or by league Ids from BFF
     * @param {request} EventsByEventIdOrByLeagueIdRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    getByEventIdOrByLeagueId(request) {
        let fetchOptions = {
            request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.BY_EVENT_ID_OR_BY_LEAGUE_ID, fetchOptions);
    }
    /**
     * Fetch outright events by league id
     * @param {request} OutrightEventsByLeagueIdRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    getFromOutrightByLeagueId(request) {
        let fetchOptions = {
            request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.FROM_OUTRIGHT_BY_LEAGUE_ID, fetchOptions);
    }
    /**
     * Fetch personalized live events from BFF, based on a selected event's id
     * @param {request} PersonalizedLiveEventsRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    getPersonalizedEvents(request) {
        let fetchOptions = {
            request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.PERSONALIZED_LIVE_EVENTS_BY_ID, fetchOptions);
    }
    /**
     * Fetch events and markets from BFF, used for Betslip integration
     * @param {request} EventsByEventIdForBetSlipRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    getByIdForBetslip(request) {
        let fetchOptions = {
            request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.BY_ID_FOR_BETSLIP, fetchOptions);
    }
    /**
    * Fetch personalized events by sport ids
    * @param {PersonalizedEventsPerSportRequest} request
    * @throws {RequiredError}
    * @memberof EventsApiClient
    */
    getPersonalizedPreLiveEventsBySportId(request) {
        let fetchOptions = {
            request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.PERSONALIZED_PRELIVE_BY_SPORT_ID, fetchOptions);
    }
    /**
    * Fetch personalized prelive events
    * @param {PersonalizedPreLiveEventsRequest} request
    * @throws {RequiredError}
    * @memberof EventsApiClient
    */
    getPersonalizedPreLiveEvents(request) {
        let fetchOptions = {
            request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.PERSONALIZED_PRELIVE_EVENTS, fetchOptions);
    }
}
//# sourceMappingURL=EventsApiClient.js.map